exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gc_select_form {\n  color: rgba(0, 0, 0, 0.85);\n  font-family: PingFangSC-Regular;\n  font-size: 16px;\n}\n.gc_select_form_package_input {\n  width: 260px;\n}\n.gc_select_form .ant-select-selection--single {\n  height: 40px;\n  display: flex;\n  align-items: center;\n}\n", ""]);

